import { create } from 'zustand';

/**
 * Lets whatever is pointing at the settings nav button send it somewhere more specific for as long
 * as it points there. The nav is rendered by the shell, so a module-level store is what it and the
 * page pointing at it have in common.
 *
 * Only the build details AI signpost sets it today (CI-6462): while its popover is up, the gear
 * goes straight to the workspace AI settings instead of the settings root. Navigating away is a
 * full page load, which drops the override with the rest of the page state.
 */
type SettingsNavOverride = {
  href: string | null;
  setHref: (href: string | null) => void;
};

const useSettingsNavOverride = create<SettingsNavOverride>((set) => ({
  href: null,
  setHref: (href) => set({ href }),
}));

export const useSettingsNavHrefOverride = () => useSettingsNavOverride((state) => state.href);

export const setSettingsNavHrefOverride = (href: string | null) => useSettingsNavOverride.getState().setHref(href);

export default useSettingsNavOverride;
